import {
  getDocListByTrack,
  getDriverInfo as getDriverInfoApi,
  getShareInfo as getShareInfoApi,
  listMessage
} from '@/api/share-tracking'
import axios from 'axios'

const CancelToken = axios.CancelToken

const DRIVER_DETAIL = {
  name: 'Anonymous driver',
  avatar: ''
}

function closeRequest(token) {
  if (token.cancel) {
    token.cancel('cancel request')
  } else if (Array.isArray(token)) {
    token.map(item => {
      closeRequest(item)
    })
  } else if (token) {
    Object.values(token).map(item => {
      closeRequest(item)
    })
  }
}

const state = {
  namespaced: true,
  state: {
    docList: [],
    docLoading: false,
    docType: [],
    version: '',
    shareId: '',
    driverDetail: Object.assign({}, DRIVER_DETAIL),
    addDocFirst: true,
    isExpire: false,
    shareInfo: {},
    mapFinish: false,
    listMessages: [],
    messageLoading: false,
    axiosToken: {},
    refresh: false,
    isShowEditButton: true
  },
  mutations: {
    SET_DOC_LIST(state, result) {
      state.docList = result
    },
    SET_LIST_MESSAGES(state, result) {
      state.listMessages = result
    },
    SET_MESSAGE_LOADING(state, result) {
      state.messageLoading = result
    },
    SET_DOC_TYPE(state, result) {
      state.docType = result
    },
    SET_DOC_LOADING(state, result) {
      state.docLoading = result
    },
    SET_DOC_VERSION(state, result) {
      state.version = result
    },
    SET_SHARE_ID(state, shareId) {
      state.shareId = shareId
    },
    SET_DRIVER_DETAIL(state, driverDetail) {
      state.driverDetail = driverDetail
    },
    SET_ADD_DOC_FIRST(state, status) {
      state.addDocFirst = status
    },
    SET_IS_EXPIRE(state, status) {
      state.isExpire = status
    },
    SET_SHARE_INFO(state, shareInfo) {
      state.shareInfo = shareInfo
    },
    SET_MAP_FINISH(state, status) {
      state.mapFinish = status
    },
    SET_AXIOS_TOKEN(state, info) {
      state.axiosToken = info
    },
    SET_REFRESH(state, status) {
      state.refresh = status
    },
    SET_SHOW_EDIT_TRIP_BUTTON(state, status) {
      state.isShowEditButton = status
    },
    INIT_STATE(state) {
      state.driverDetail = Object.assign({}, DRIVER_DETAIL)
      state.addDocFirst = true
      state.isExpire = false
      state.shareInfo = {}
      state.mapFinish = false
      state.listMessages = []
      state.docList = []
      state.messageLoading = false
      state.refresh = false
    }
  },
  actions: {
    updateFristUpload({commit}, data) {
      commit('SET_ADD_DOC_FIRST', data)
    },
    updateRefresh({ commit }, status) {
      commit('SET_REFRESH', status)
    },
    updateShareId({ commit }, shareId) {
      commit('SET_SHARE_ID', shareId)
    },
    updateMessgaeList({commit}, id) {
      commit('SET_MESSAGE_LOADING', true)
      listMessage(id).then(res => {
        console.log(res, 'message')
        commit('SET_LIST_MESSAGES', res.data)
      }).finally(() => {
        commit('SET_MESSAGE_LOADING', false)
      })
    },
    updateMapFinish({ commit }, status) {
      commit('SET_MAP_FINISH', status)
    },
    updateDriverDetail({ commit }, info) {
      commit('SET_DRIVER_DETAIL', info)
    },
    updateAxiosToken({ commit }, info) {
      commit('SET_AXIOS_TOKEN', info)
    },
    closeAllRequest({ dispatch, state }) {
      closeRequest(state.axiosToken)
      dispatch('updateAxiosToken', {})
    },
    getDocList({ commit }, id) {
      commit('SET_DOC_LOADING', true)
      return getDocListByTrack(id).then(res => {
        console.log(res)
        commit('SET_DOC_LIST', res.data?.fileList || [])
        commit('SET_DOC_VERSION', res.data?.version)
        let arr = []
        if (res.data?.typeConfig) {
          arr = res.data.typeConfig.map(item => {
            return {
              label: item.type,
              value: item.rank
            }
          })
        }
        commit('SET_DOC_TYPE', arr || [])
      }).finally(() => {
        commit('SET_DOC_LOADING', false)
      })
    },
    getDriverInfo({ state, commit, dispatch }) {
      let source = CancelToken.source()
      if (state.axiosToken.getDriverInfo) {
        state.axiosToken.getDriverInfo.cancel('cancel request')
      }
      dispatch('updateAxiosToken', { ...state.axiosToken, getDriverInfo: source })
      return getDriverInfoApi(state.shareId, source.token).then(res => {
        console.log(res, '111sh')
        commit('SET_DRIVER_DETAIL', Object.assign({}, state.driverDetail, res.data, { name: res.data.name || 'Anonymous driver' }))
        commit('SET_ADD_DOC_FIRST', !res.data.uploadedFile)
        return Promise.resolve(res.data)
      })
    },
    getShareInfo({ state, commit, dispatch }) {
      let source = CancelToken.source()
      if (state.axiosToken.getShareInfo) {
        state.axiosToken.getShareInfo.cancel('cancel request')
      }
      dispatch('updateAxiosToken', { ...state.axiosToken, getShareInfo: source })
      return getShareInfoApi({ shareId: state.shareId }, source.token).then(res => {
        let sharedTripId = sessionStorage.getItem('SharedTripId')
        let data = res.data || {}
        let info = {
          ...data,
          tripShareId: state.shareId,
          waypoints: data.waypoints ? JSON.parse(data.waypoints) : []
        }
        commit('SET_IS_EXPIRE', data.status === 0)
        commit('SET_SHARE_INFO', info)
        if (sharedTripId === state.shareId) {
          sessionStorage.setItem('SharedTrip', JSON.stringify(info))
        }
        return Promise.resolve(info)
      })
    },
    initShareTrip({ commit, dispatch }) {
      commit('INIT_STATE')
      dispatch('closeAllRequest')
      return Promise.all([
        dispatch('getDriverInfo'),
        dispatch('getShareInfo')
      ])
    }
  },
  modules: {

  },
  getters: {
    docType: state => state.docType,
    docList: state => state.docList,
    version: state => state.version,
    mapFinish: state => state.mapFinish,
    isExpire: state => state.isExpire,
    shareId: state => state.shareId,
    driverDetail: state => state.driverDetail,
    addDocFirst: state => state.addDocFirst,
    shareInfo: state => state.shareInfo,
    listMessages: state => state.listMessages,
    messageLoading: state => state.messageLoading,
  }
}

export default state